import { LOGIN_RESULT } from '../user/actions'

export const currentToken = (state = null, action) => {
    switch (action.type) {
        case LOGIN_RESULT:
            if (action.error)
                return state
            return action.token

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/currentToken/index.js